/**
 * @author        quanquan
 * @dateTime      2020-09-07 09:42:28
 * @description
 */

/* eslint-disable */

export function checkIp (ip) {
  var pcount = 0
  var ip_length = ip.length
  var ip_letters = '1234567890.'
  for (var p = 0; p < ip_length; p++) {
    var ip_char = ip.charAt(p)
    if (ip_letters.indexOf(ip_char) == -1) {
      return false
    }
  }
  for (var u = 0; u < ip_length; u++) { (ip.substr(u, 1) == '.') ? pcount++ : pcount }
  if (pcount != 3) { return false }
  var firstp = ip.indexOf('.')
  var lastp = ip.lastIndexOf('.')
  var str1 = ip.substring(0, firstp)
  var ipstr_tmp = ip.substring(0, lastp)
  var secondp = ipstr_tmp.lastIndexOf('.')
  var str2 = ipstr_tmp.substring(firstp + 1, secondp)
  var str3 = ipstr_tmp.substring(secondp + 1, lastp)
  var str4 = ip.substring(lastp + 1, ip_length)
  if (str1 == '' || str2 == '' || str3 == '' || str4 == '') { return false }
  if (str1.length > 3 || str2.length > 3 || str3.length > 3 || str4.length > 3) { return false }
  if (str1 <= 0 || str1 > 255) { return false } else if (str2 < 0 || str2 > 255) { return false } else if (str3 < 0 || str3 > 255) { return false } else if (str4 < 0 || str4 > 255) { return false }
  return true
}



// WEBPACK FOOTER //
// ./src/js/module/utils/IPAddress.js